import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogArrayComponent } from '../dialog/template/dialog-json-buider/dialog-array/dialog-array.component';
import { DialogObjectComponent } from '../dialog/template/dialog-json-buider/dialog-object/dialog-object.component';
import { DialogPropertyComponent } from '../dialog/template/dialog-json-buider/dialog-property/dialog-property.component';
import { JsonBuilderService } from './json-builder.service';
import { IButtonAddAttribute } from './templates-json/template-button-add-attribute/template-button-add-attribute.component';

@Component({
  selector: 'app-json-builder',
  templateUrl: './json-builder.component.html',
  styleUrls: ['./json-builder.component.scss']
})
export class JsonBuilderComponent implements OnInit {
  @Input() data = {};
  @Input() rootName: string;
  public hasItems: boolean = false;

  public configHeader = {
    disableSettingButton: true,
    hidden: true
  }

  public configButtonAddAttribute: IButtonAddAttribute = {
    withoutItemMessage: "Objeto vazio, adicione atributos",
    btnAddMessage: "Adicionar atributo",
    hiddenWithoutItemMessage: this.hasItems
  }
  public breadcrumb;

  constructor(private dialog: MatDialog, public jsonBuilderService: JsonBuilderService) {
    const fields = this.jsonBuilderService.getOptions() ?? [];
    if (fields.length === 0) {
      throw "Você precisa setar o field no serviço JsonBuilderService";
    }
  }

  ngOnInit(): void {
    if (this.data == undefined || this.data == null) {
      this.data = {}
    }
    this.checkHasItem();
    this.breadcrumb = {
      root: this.rootName,
      whereThis: []
    }
  }

  private checkHasItem() {
    this.hasItems = !!Object.keys(this.data).length;
    this.configButtonAddAttribute.hiddenWithoutItemMessage = this.hasItems;
  }

  public addAttribute(type: 'object' | 'array' | 'item') {
    switch (type) {
      case 'object':
        return this.addObject();
      case 'array':
        return this.addArray();
      case 'item':
        return this.addItem();
    }
  }

  public addObject() {
    this.dialog.open(DialogComponent, {
      width: '1080px',
      minHeight: '600px',
      disableClose: true,
      data: {
        titleDialog: 'Objeto',
        titleButton: 'Salvar',
        component: DialogObjectComponent,
        contentDialogClassName: 'dialog-content',
        data: {
          data: {},
          root: this.data
        },
        breadcrumb: JSON.parse(JSON.stringify(this.breadcrumb))
      },
      autoFocus: false
    }).afterClosed().subscribe(() => this.checkHasItem());
  }

  public addArray() {
    this.dialog.open(DialogComponent, {
      width: '1080px',
      minHeight: '600px',
      disableClose: true,
      data: {
        titleDialog: 'Array',
        titleButton: 'Salvar',
        component: DialogArrayComponent,
        contentDialogClassName: 'dialog-content',
        data: {
          data: [],
          root: this.data
        },
        breadcrumb: JSON.parse(JSON.stringify(this.breadcrumb))
      },
      autoFocus: false
    }).afterClosed().subscribe(() => this.checkHasItem());
  }

  public addItem() {
    this.dialog.open(DialogComponent, {
      width: '1080px',
      minHeight: '600px',
      disableClose: true,
      data: {
        titleDialog: 'Valor',
        titleButton: 'Salvar',
        component: DialogPropertyComponent,
        contentDialogClassName: 'dialog-content',
        data: {
          data: "",
          root: this.data
        },
        breadcrumb: JSON.parse(JSON.stringify(this.breadcrumb))
      },
      autoFocus: false
    }).afterClosed().subscribe(() => this.checkHasItem());
  }

  delete() {
    this.data = {};
    this.checkHasItem();
  }
}
